module.exports = __webpack_public_path__ + "static/img/022.10ebc7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/022.png
// module id = sw6a
// module chunks = 0